import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { AuthProvider } from "./context/AuthContext";
import { DeviceProvider } from "./context/DeviceContext";
import { DirectoryProvider } from "./context/DirectoryContext";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <DeviceProvider>
        <DirectoryProvider>
          <App />
        </DirectoryProvider>
      </DeviceProvider>
    </AuthProvider>
  </React.StrictMode>
);
